/* eslint-disable import/no-default-export */
export default {
  'AgenticDuoChat.chatCancelLabel': 'Cancel',
  'AgenticDuoChat.chatDefaultPredefinedPromptsChangePassword':
    'How do I change my password in GitLab?',
  'AgenticDuoChat.chatDefaultPredefinedPromptsCloneRepository': 'How do I clone a repository?',
  'AgenticDuoChat.chatDefaultPredefinedPromptsCreateTemplate': 'How do I create a template?',
  'AgenticDuoChat.chatDefaultPredefinedPromptsForkProject': 'How do I fork a project?',
  'AgenticDuoChat.chatDefaultTitle': 'GitLab Duo Chat',
  'AgenticDuoChat.chatDisclamer': 'Responses may be inaccurate. Verify before use.',
  'AgenticDuoChat.chatEmptyStateTitle':
    '👋 I am GitLab Duo Chat, your personal AI-powered assistant. How can I help you today?',
  'AgenticDuoChat.chatHistoryTitle': 'Chat history',
  'AgenticDuoChat.chatPromptPlaceholderDefault': 'GitLab Duo Chat',
  'AgenticDuoChat.chatPromptPlaceholderWithCommands': 'Type /help to learn more',
  'AgenticDuoChat.chatSubmitLabel': 'Send chat message.',
  'DuoChat.chatBackLabel': 'Back to History',
  'DuoChat.chatCancelLabel': 'Cancel',
  'DuoChat.chatDefaultPredefinedPromptsChangePassword': 'How do I change my password in GitLab?',
  'DuoChat.chatDefaultPredefinedPromptsCloneRepository': 'How do I clone a repository?',
  'DuoChat.chatDefaultPredefinedPromptsCreateTemplate': 'How do I create a template?',
  'DuoChat.chatDefaultPredefinedPromptsForkProject': 'How do I fork a project?',
  'DuoChat.chatDefaultTitle': 'GitLab Duo Chat',
  'DuoChat.chatEmptyStateTitle':
    '👋 I am GitLab Duo Chat, your personal AI-powered assistant. How can I help you today?',
  'DuoChat.chatHistoryInfo': 'Inactive chats are deleted after 30 days.',
  'DuoChat.chatHistoryToolTip': 'Chat History',
  'DuoChat.chatNewLabel': 'New Chat',
  'DuoChat.chatNewToolTip': 'New Chat',
  'DuoChat.chatPromptPlaceholderDefault': 'GitLab Duo Chat',
  'DuoChat.chatPromptPlaceholderWithCommands': 'Type /help to learn more',
  'DuoChat.chatSubmitLabel': 'Send chat message.',
  'DuoChat.chatTitle': 'GitLab Duo Chat',
  'DuoChat.closeChatHeaderLabel': 'Close Chat',
  'DuoChat.emptyHistoryAlt':
    'Clock icon with circular arrow, indicating chat history or time-based functionality',
  'DuoChat.emptyHistoryCopy': 'Your previous chats will appear here.',
  'DuoChat.emptyHistoryTitle': 'See your chat history',
  'DuoChat.openChatLabel': 'Open chat: %{title}',
  'DuoChat.threadDeleteLabel': 'Delete this thread.',
  'DuoChatContextItemDetailsModal.contentErrorMessage': 'Item content could not be displayed.',
  'DuoChatContextItemDetailsModal.title': 'Preview',
  'DuoChatContextItemMenu.emptyStateMessage': 'No results found',
  'DuoChatContextItemMenu.loadingMessage': 'Loading...',
  'DuoChatContextItemMenu.searchInputPlaceholder': 'Search %{categoryLabel}...',
  'DuoChatContextItemMenu.selectedContextItemsTitle': 'Included references',
  'DuoChatContextItemPopover.DisabledReason': 'This item is disabled',
  'DuoChatConversation.newChat': 'New chat',
  'DuoChatLoader.gitlabDuo': 'GitLab Duo',
  'DuoChatLoader.loaderLoadingMessage': '%{tool} is %{transition} an answer',
  'DuoChatLoader.loaderLoadingTransitionsFinding': 'finding',
  'DuoChatLoader.loaderLoadingTransitionsGenerating': 'generating',
  'DuoChatLoader.loaderLoadingTransitionsProducing': 'producing',
  'DuoChatLoader.loaderLoadingTransitionsWorkingOn': 'working on',
  'DuoChatMessage.SelectedContextItemsTitleAssistantMessage': null,
  'DuoChatMessage.SelectedContextItemsTitleUserMessage': null,
  'DuoChatMessage.chatMessageCopied': 'Copied',
  'DuoChatMessage.chatMessageCopyToClipboard': 'Copy to clipboard',
  'DuoChatMessage.fromDuo': 'Duo:',
  'DuoChatMessage.fromMe': 'Me:',
  'DuoChatMessage.modalAlertText':
    'GitLab team members cannot view your conversation. Please be as descriptive as possible.',
  'DuoChatMessage.modalBetterResponse': 'How the response might better meet your needs.',
  'DuoChatMessage.modalDidWhat': 'What were you doing?',
  'DuoChatMessage.modalImproveWhat': 'How could the response be improved?',
  'DuoChatMessage.modalInteraction': 'The situation in which you interacted with GitLab Duo Chat.',
  'DuoChatMessage.modalMessageError': 'Error sending the message',
  'DuoChatMessage.modalTitle': 'Give feedback on GitLab Duo Chat',
  'DuoChatMessageSources.messageSources': null,
  'GlDuoChat.chatDisclamer': 'Responses may be inaccurate. Verify before use.',
  'GlDuoChat.chatHistoryTitle': 'Chat history',
  'GlDuoWorkflowPanel.collapseButtonTitle': 'Collapse',
  'GlDuoWorkflowPanel.expandButtonTitle': 'Expand',
  'GlDuoWorkflowPrompt.cancelButtonText': 'Cancel',
  'GlDuoWorkflowPrompt.confirmButtonText': 'Generate plan',
  'GlDuoWorkflowPrompt.imageDescription':
    'It should have any tools necessary for the workflow installed.',
  'GlDuoWorkflowPrompt.imageLabel': 'Image',
  'GlDuoWorkflowPrompt.imageLabelDescription': 'The container image to run the workflow in.',
  'GlDuoWorkflowPrompt.promptDescription': 'Be specific and include any requirements.',
  'GlDuoWorkflowPrompt.promptLabel': 'Description',
  'GlDuoWorkflowPrompt.promptLabelDescription': 'What would you like to do and how.',
  'GlDuoWorkflowPrompt.title': 'Goal',
};
